import React, { Fragment } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import AppInnerFooter from "Layout/AppInnerFooter";
import { Button, Card, CardBody, CardFooter, Col, Container, Row } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import DefaultButton from "Components/Buttons/DefaultButton";
import { useState } from "react";
import classNames from "classnames";
import SweetAlert from "react-bootstrap-sweetalert";

const getNavStates = (indx, length) => {
    let styles = [];
    for (let i = 0; i < length; i++) {
        if (i < indx) {
            styles.push("done");
        } else if (i === indx) {
            styles.push("doing");
        } else {
            styles.push("todo");
        }
    }
    return { current: indx, styles: styles };
};


const MultiStep = (props) => {
   
    const [showPreviousBtn, setShowPreviousBtn] = useState(false);
    const [showNextBtn, setShowNextBtn] = useState(true);
    const [compState, setCompState] = useState(0);
    const [navState, setNavState] = useState(getNavStates(0, props.steps.length));
    const [showModal, setShowModal] = useState(false);

    const checkNavState = (currentStep, stepsLength) => {
        if (currentStep > 0 && currentStep < stepsLength - 1) {
            setShowPreviousBtn(true);
            setShowNextBtn(true)
        } else if (currentStep === 0) {
            setShowPreviousBtn(false);
            setShowNextBtn(true)
        } else {
            setShowPreviousBtn(true);
            setShowNextBtn(false)
        }
    };

    const setNavStates = (next) => {
        setNavState(getNavStates(next, props.steps.length));

        if (next < props.steps.length) {
            setCompState(next);
        }
        checkNavState(next, props.steps.length);
    };

    const handleOnClick = (evt) => {
        if (
            evt.currentTarget.value === props.steps.length - 1 &&
            compState === props.steps.length - 1
        ) {
            setNavStates(props.steps.length);
        } else {
            setNavStates(evt.currentTarget.value);
        }
    };

    const next = e => {
        // validate if all necessary fields are selected
        if (
            Object.keys(props.formikProps.errors).length > 1
            || props.leaveLink !== null
            && props.leaveLink.length !== 0
            && props.formikProps.values.type.length == 0
        ) {
            props.setDisabled(true);
        } else {
            props.setDisabled(false);
            setNavStates(compState + 1);
        }
    };

    const previous = () => {
        if (compState > 0) {
            setNavStates(compState - 1);
        }
    };

    const getClassName = (className, i) => {
        return className + "-" + navState.styles[i];
    };

    const renderSteps = () => {
        return props.steps.map((s, i) => (
            <li
                className={getClassName("form-wizard-step", i)}
                onClick={e => {
                    // validate if all necessary fields are selected
                    if (
                        Object.keys(props.formikProps.errors).length > 1
                        || props.leaveLink.length !== 0
                        && props.formikProps.values.type.length == 0
                    ) {
                        props.setDisabled(true);
                    } else {
                        props.setDisabled(false);
                        handleOnClick(e);
                    }
                }}
                key={i}
                value={i}
            >
                <em>{i + 1}</em>
                <span>{props.steps[i].name}</span>
            </li>
        ));
    };


    return (
        <Fragment>
            <PageHeading />

            <TransitionOnLoad>
                <Row>
                    <Col md="12">
                        <Card className="main-card mb-3">
                            <CardBody className="p-3">
                                <div>
                                    <ol className="forms-wizard">{renderSteps()}</ol>
                                    <Container className="px-0">

                                        {props.steps[compState].component}

                                        {/* <div className="divider" /> */}
                                        {/* <div className="clearfix">
                                            <div className={classNames({ "row": showNextBtn })} style={props.showNavigation ? {} : { display: "none" }}>

                                                {
                                                    !showNextBtn && (
                                                        <DefaultButton
                                                            onClick={() => {

                                                                if (props.formikProps.values.dateRange.length === 0) {

                                                                    setShowModal(true);
                                                                } else {

                                                                    props.handleSubmit();
                                                                }
                                                            }}
                                                            type="button"
                                                            className={"float-end ms-2 btn-color-style"}
                                                            disabled={props.disabledButton}
                                                        >
                                                            Toevoegen
                                                        </DefaultButton>
                                                    )
                                                }

                                                {showNextBtn && <div className="col row px-4"><span className="d-inline-block col-3"></span><span className="col px-4">* Verplichte velden</span></div>}

                                                {showNextBtn &&
                                                    <div className="col">
                                                        <DefaultButton onClick={next} className={"float-end btn-color-style"}>
                                                            Volgende
                                                        </DefaultButton>
                                                    </div>
                                                }

                                                {showPreviousBtn &&
                                                    <DefaultButton onClick={previous} className={"float-end btn-color-style"}>
                                                        Vorige
                                                    </DefaultButton>
                                                }
                                                <SweetAlert
                                                    title="Selecteer minimaal 1 dagdeel"
                                                    show={showModal}
                                                    type="warning"
                                                    onConfirm={() => setShowModal(false)}
                                                    confirmBtnText={"Sluiten"}
                                                />

                                            </div>
                                        </div> */}
                {showNextBtn && <div className="col row px-4"><span className="d-inline-block col-3"></span><span className="col px-4">* Verplichte velden</span></div>}
                                    </Container>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </TransitionOnLoad>
            <div>

                <AppInnerFooter
                            footerWrapperClassName="footer--coordinator-planboard"
                            cardFooterClassName="flex-wrap flex-xxl-nowrap gap-2 justify-content-end margin-bottom-20 "
                          >
                    <div className="d-flex justify-content-end">
                            <div className={classNames({ "row": showNextBtn })} style={props.showNavigation ? {} : { display: "none" }}>

                                {
                                    !showNextBtn && (
                                        <DefaultButton
                                            onClick={() => {

                                                if (props.formikProps.values.dateRange.length === 0) {

                                                    setShowModal(true);
                                                } else {

                                                    props.handleSubmit();
                                                }
                                            }}
                                            type="button"
                                            className={"float-end ms-2 btn-color-style"}
                                            disabled={props.disabledButton}
                                        >
                                            Toevoegen
                                        </DefaultButton>
                                    )
                                }


                                {showNextBtn &&
                                    <div className="col">
                                        <DefaultButton onClick={next} className={"float-end btn-color-style"}>
                                            Volgende
                                        </DefaultButton>
                                    </div>
                                }

                                {showPreviousBtn &&
                                    <DefaultButton onClick={previous} className={"float-end btn-color-style"}>
                                        Vorige
                                    </DefaultButton>
                                }
                                <SweetAlert
                                    title="Selecteer minimaal 1 dagdeel"
                                    show={showModal}
                                    type="warning"
                                    onConfirm={() => setShowModal(false)}
                                    confirmBtnText={"Sluiten"}
                                />

                          
                        </div>
                    </div>
                </AppInnerFooter>
            </div>
          
        </Fragment>
    );
}

export default MultiStep;

MultiStep.defaultProps = {
    showNavigation: true,
};
